import { render } from "./ExamPartnerResultsTab.vue?vue&type=template&id=24cc9a9a&scoped=true"
import script from "./ExamPartnerResultsTab.vue?vue&type=script&lang=js"
export * from "./ExamPartnerResultsTab.vue?vue&type=script&lang=js"

import "./ExamPartnerResultsTab.vue?vue&type=style&index=0&id=24cc9a9a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cc9a9a"]])

export default __exports__